/*
 * description: 全局样式变量配置，颜色、字体等
 */
import type { FlexAlignType, TextStyle } from "../platformComponents";
import { Dimensions, Platform, StyleSheet } from "../platformComponents";
import { tranformPx } from "@adgm/libs";
import { darkThemeColors } from "./dark";
import { lightThemeColors } from "./light";
import NamedStyles = StyleSheet.NamedStyles;

export const mainPadding = Platform.OS === "ios" ? tranformPx(14) : tranformPx(20);

// 这里iOS使用合并字体偶现加载失败，中文字体系统默认苹方
export const fontFamily = {
  commonRegular: "DINPro-Regular",
  commonMedium: "DINPro-Medium",
  commonBold: "DINPro-Bold",
};

// added below colors, fonts, padding etc
// colors除了通用颜色定义，还有dark和light单独主题配置
export const colors = {
  mainBackground: "#141414",
  mainBackgroundWeb: "#1f212f",
  mainBackgroundLight: "#181818",
  mainTextColor: "#ffffff",
  noMoreColor: "#5A5A5A",
  TextColor2: "#ADADAD",
  TextColor3: "#5B5B5B",
  TextColor4: "#D9D9D9",
  TextColor5: "#8f8f8f",
  TextColor6: "#AFAFAF",
  TextColor7: "#666666",
  TextColor8: "#808080",
  TextColor9: "#EFEFEF",
  TextColor10: "#ADAEB4",
  TextColor11: "#4d4d4d",
  TextColor12: "#9799A0",
  textInputBorderColor: "#373737",
  tabBackgroundColor: "#1B1919",
  tabBarInactive: "#696F7F",
  tabBarActive: "#eaa126",
  borderColor1: "#202020",
  borderColor2: "#373737",
  borderColor3: "#3d3d3d",
  highlightColor: "#F17E00",
  highlightColor1: "rgba(241, 126, 0, 0.4)",
  highlightColor2: "rgba(241, 126, 0, 0.1)",
  highlightColor3: "rgba(241, 126, 0, 0.3)",
  graylightColor: "#7D7D7D",
  dottedColor: "#8E8E8E",
  dottedColor1: "#505050",
  modalBackground: "#282828",
  modalBackgroundColor: "#282828",
  tradeModalBackgroundColor: "#202020",
  tradeInputPlaceholderTextColor: "rgba(255, 255, 255, 0.2)",
  backgroundColor1: "rgba(146, 146, 146, 0.3)",
  splitLineColor: "#434343",
  transparent: "transparent",
  white: "#FFFFFF",
  white1: "#F6F6F6",
  white2: "#F7F7F8",
  white3: "#F9F9FA",
  white4: "#FBFBFB",
  white5: "#D8D8D8",
  white6: "rgba(255,255,255,0.8)",
  white7: "rgba(255,255,255,0.2)",
  white8: "#EDEDED",
  white9: "#F2F1F5",
  white10: "#F5F5F5",
  white11: "#F6F5FA",
  white12: "#BCBFC5",
  white13: "#EBE7F6",
  white14: "rgba(255,255,255,0.7)",
  white15: "rgba(255,255,255,0.1)",
  white16: "rgba(255,255,255,0.85)",
  white17: "rgba(255,255,255,0.75)",
  white18: "rgba(255,255,255,0.6)",
  white19: "#F5F8FA",
  white21: "rgba(255,255,255,0.4)",
  white20: "rgba(255,255,255,0.4)",
  white22: "rgba(255,255,255,0.5)",
  white23: "rgba(255,255,255,0.14)",
  white24: "#F8FAFC",
  white25: "rgba(255,255,255,0.68)",
  gray1: "#696F7F",
  gray2: "rgba(142,147,159,0.46)",
  gray3: "#8E939F",
  grey4: "#D9DBDF",
  grey5: "#979797",
  grey6: "#EBE9F1",
  grey7: "#646464",
  grey8: "#8F8F8F",
  grey9: "#2E2E2E",
  grey10: "#9E9E9E",
  grey11: "#2F2F2F",
  grey12: "#44413F",
  grey13: "#525252",
  grey14: "#8B8B8B",
  grey15: "#ACACAC",
  grey16: "#191919",
  grey18: "#909090",
  grey20: "#181818",
  grey21: "#4D4E57",
  grey22: "#2F3342",
  grey23: "#101010",
  grey24: "rgba(137,137,137,0.6)",
  grey25: "#3A3A3A",
  grey26: "rgb(217,217,217)",
  grey27: "rgba(217,217,217,0.3)",
  grey28: "rgba(31, 31, 31, 0.64)",
  grey29: "rgba(142,142,142,0.1)",
  grey30: "#898989",
  grey31: "#B5B5B5",
  grey32: "rgba(92,92,92,0.89)",
  grey33: "#131313",
  grey34: "#1C1C1C",
  grey35: "#2D2D2D",
  black: "#000",
  black1: "#434B5F",
  black2: "rgba(0,0,0,0.6)",
  black3: "#1F2126",
  black4: "rgba(0,0,0,0.4)",
  black5: "#AFB3BD",
  black6: "rgba(0,0,0,0.1)",
  black7: "rgba(0,0,0,0.5)",
  black8: "rgba(24, 24, 24, 0.94)",
  black9: "#0E0E0E",
  black10: "rgba(0,0,0,0.94)",
  blackOp: "#1F212F00",
  black12: "rgba(11,17,21,0.8)",
  red: "#ED220D",
  red1: "#F0506C",
  red2: "#E23030",
  red3: "#D91F05",
  red4: "#FF3F3E",
  red5: "#FA5151",
  red6: "rgba(235, 21, 21, 0.2)",
  red7: "rgba(235, 21, 21, 0.6)",
  red8: "#CB1719",
  red9: "rgba(235, 21, 21, 0.8)",
  red10: "rgba(247, 98, 96, 0.20)",
  red11: "rgba(247, 98, 96)",
  red12: "#F76260",
  red13: "rgba(247, 98, 96, 0.10)",
  red14: "#F10000",
  green: "#1EAE45",
  green1: "#06BC39",
  green2: "#07C160",
  green3: "#00B05C",
  green4: "#21BF73",
  green5: "rgba(33, 191, 115, 0.10)",
  purple: "#6F40EE",
  purple2: "#7600F6",
  purple3: "#74219B",
  blue: "#4A5BF2",
  blue1: "#0060F1",
  blue2: "rgb(2,34,80)",
  blue4: "#10AEFF",
  blue3: "#0094FF",
  blue5: "#507DC9",
  blue6: "rgba(16, 174, 255, 0.10)",
  blue7: "#62F3EA",
  blue8: "#67A7A3",
  blue9: "#6BF2E9",
  blue10: "#057DDE",
  lightPurple: "rgba(111,64,238,0.1)",
  tagBg: "rgba(241,126,0,0.15)",
  timeStartColor: "rgb(22,57,32)",
  timeProgressColor: "rgb(69,27,26)",
  timeEndColor: "rgb(67,40,8)",
  orange: "#F45F22",
  orange2: "#F27703",
  orange3: "#FFB323",
  orange4: "#f1bc00",
  orange5: "#F0A418",

  ...darkThemeColors,
  ...lightThemeColors,
};

export const width = {
  w1: tranformPx(1),
  w2: tranformPx(2),
  w3: tranformPx(3),
  w4: tranformPx(4),
  w5: tranformPx(5),
  w6: tranformPx(6),
  w7: tranformPx(7),
  w8: tranformPx(8),
  w9: tranformPx(9),
  w10: tranformPx(10),
  w11: tranformPx(11),
  w12: tranformPx(12),
  w13: tranformPx(13),
  w14: tranformPx(14),
  w15: tranformPx(15),
  w16: tranformPx(16),
  w18: tranformPx(18),
  w20: tranformPx(20),
  w21: tranformPx(21),
  w23: tranformPx(23),
  w24: tranformPx(24),
  w25: tranformPx(25),
  w26: tranformPx(26),
  w27: tranformPx(27),
  w28: tranformPx(28),
  w30: tranformPx(30),
  w31: tranformPx(31),
  w32: tranformPx(32),
  w33: tranformPx(33),
  w36: tranformPx(36),
  w39: tranformPx(39),
  w40: tranformPx(40),
  w41: tranformPx(41),
  w42: tranformPx(42),
  w43: tranformPx(43),
  w44: tranformPx(44),
  w46: tranformPx(46),
  w47: tranformPx(47),
  w48: tranformPx(48),
  w50: tranformPx(50),
  w52: tranformPx(52),
  w56: tranformPx(56),
  w57: tranformPx(57),
  w64: tranformPx(64),
  w60: tranformPx(60),
  w61: tranformPx(61),
  w62: tranformPx(62),
  w63: tranformPx(63),
  w65: tranformPx(65),
  w68: tranformPx(68),
  w70: tranformPx(70),
  w72: tranformPx(72),
  w74: tranformPx(74),
  w77: tranformPx(77),
  w78: tranformPx(78),
  w80: tranformPx(80),
  w82: tranformPx(82),
  w84: tranformPx(84),
  w86: tranformPx(86),
  w88: tranformPx(88),
  w90: tranformPx(90),
  w91: tranformPx(91),
  w92: tranformPx(92),
  w96: tranformPx(96),
  w100: tranformPx(100),
  w105: tranformPx(105),
  w112: tranformPx(112),
  w120: tranformPx(120),
  w121: tranformPx(121),
  w127: tranformPx(127),
  w128: tranformPx(128),
  w132: tranformPx(132),
  w140: tranformPx(140),
  w144: tranformPx(144),
  w152: tranformPx(152),
  w156: tranformPx(156),
  w160: tranformPx(160),
  w166: tranformPx(166),
  w170: tranformPx(170),
  w176: tranformPx(176),
  w192: tranformPx(192),
  w199: tranformPx(199),
  w200: tranformPx(200),
  w210: tranformPx(210),
  w220: tranformPx(220),
  w223: tranformPx(223),
  w230: tranformPx(230),
  w235: tranformPx(235),
  w242: tranformPx(242),
  w247: tranformPx(247),
  w288: tranformPx(288),
  w300: tranformPx(300),
  w304: tranformPx(304),
  w332: tranformPx(332),
  w345: tranformPx(345),
  w360: tranformPx(360),
  w380: tranformPx(380),
  w400: tranformPx(400),
  w480: tranformPx(480),
  w500: tranformPx(500),
  w560: tranformPx(560),
  w561: tranformPx(561),
  w590: tranformPx(590),
  w600: tranformPx(600),
  w620: tranformPx(620),
  w630: tranformPx(630),
  w690: tranformPx(690),
};

export const height = {
  h1: tranformPx(1),
  h2: tranformPx(2),
  h3: tranformPx(3),
  h4: tranformPx(4),
  h5: tranformPx(5),
  h6: tranformPx(6),
  h7: tranformPx(7),
  h8: tranformPx(8),
  h9: tranformPx(9),
  h10: tranformPx(10),
  h11: tranformPx(11),
  h12: tranformPx(12),
  h13: tranformPx(13),
  h14: tranformPx(14),
  h15: tranformPx(15),
  h16: tranformPx(16),
  h17: tranformPx(17),
  h18: tranformPx(18),
  h20: tranformPx(20),
  h21: tranformPx(21),
  h22: tranformPx(22),
  h23: tranformPx(23),
  h24: tranformPx(24),
  h25: tranformPx(25),
  h26: tranformPx(26),
  h27: tranformPx(27),
  h28: tranformPx(28),
  h30: tranformPx(30),
  h31: tranformPx(31),
  h32: tranformPx(32),
  h34: tranformPx(34),
  h36: tranformPx(36),
  h38: tranformPx(38),
  h39: tranformPx(39),
  h40: tranformPx(40),
  h41: tranformPx(41),
  h42: tranformPx(42),
  h44: tranformPx(44),
  h45: tranformPx(45),
  h46: tranformPx(46),
  h48: tranformPx(48),
  h50: tranformPx(50),
  h52: tranformPx(52),
  h54: tranformPx(54),
  h56: tranformPx(56),
  h59: tranformPx(59),
  h64: tranformPx(64),
  h60: tranformPx(60),
  h62: tranformPx(62),
  h63: tranformPx(63),
  h66: tranformPx(66),
  h68: tranformPx(68),
  h72: tranformPx(72),
  h78: tranformPx(78),
  h80: tranformPx(80),
  h85: tranformPx(85),
  h87: tranformPx(87),
  h88: tranformPx(88),
  h90: tranformPx(90),
  h92: tranformPx(92),
  h96: tranformPx(96),
  h98: tranformPx(98),
  h100: tranformPx(100),
  h106: tranformPx(106),
  h108: tranformPx(108),
  h112: tranformPx(112),
  h120: tranformPx(120),
  h127: tranformPx(127),
  h124: tranformPx(124),
  h130: tranformPx(130),
  h131: tranformPx(131),
  h134: tranformPx(134),
  h136: tranformPx(136),
  h140: tranformPx(140),
  h144: tranformPx(144),
  h150: tranformPx(150),
  h154: tranformPx(154),
  h158: tranformPx(158),
  h160: tranformPx(160),
  h167: tranformPx(167),
  h168: tranformPx(168),
  h180: tranformPx(180),
  h187: tranformPx(187),
  h190: tranformPx(190),
  h192: tranformPx(192),
  h194: tranformPx(194),
  h197: tranformPx(197),
  h200: tranformPx(200),
  h208: tranformPx(208),
  h212: tranformPx(212),
  h238: tranformPx(238),
  h247: tranformPx(247),
  h248: tranformPx(248),
  h250: tranformPx(250),
  h259: tranformPx(259),
  h288: tranformPx(288),
  h300: tranformPx(300),
  h340: tranformPx(340),
  h380: tranformPx(380),
  h529: tranformPx(529),
  h680: tranformPx(680),
  h759: tranformPx(759),
};

export const padding = {
  p1: tranformPx(1),
  p2: tranformPx(2),
  p3: tranformPx(3),
  p4: tranformPx(4),
  p5: tranformPx(5),
  p6: tranformPx(6),
  p7: tranformPx(7),
  p8: tranformPx(8),
  p9: tranformPx(9),
  p10: tranformPx(10),
  p11: tranformPx(11),
  p12: tranformPx(12),
  p13: tranformPx(13),
  p14: tranformPx(14),
  p15: tranformPx(15),
  p16: tranformPx(16),
  p17: tranformPx(17),
  p18: tranformPx(18),
  p19: tranformPx(19),
  p20: tranformPx(20),
  p21: tranformPx(21),
  p22: tranformPx(22),
  p23: tranformPx(23),
  p24: tranformPx(24),
  p25: tranformPx(25),
  p26: tranformPx(26),
  p27: tranformPx(27),
  p28: tranformPx(28),
  p29: tranformPx(29),
  p32: tranformPx(32),
  p33: tranformPx(33),
  p34: tranformPx(34),
  p30: tranformPx(30),
  p35: tranformPx(35),
  p36: tranformPx(36),
  p37: tranformPx(37),
  p40: tranformPx(40),
  p42: tranformPx(42),
  p48: tranformPx(48),
  p50: tranformPx(50),
  p68: tranformPx(68),
  p100: tranformPx(100),
  pMain: mainPadding,
};

export const margin = {
  m1: tranformPx(1),
  m2: tranformPx(2),
  m3: tranformPx(3),
  m4: tranformPx(4),
  m5: tranformPx(5),
  m6: tranformPx(6),
  m7: tranformPx(7),
  m8: tranformPx(8),
  m9: tranformPx(9),
  m10: tranformPx(10),
  m11: tranformPx(11),
  m12: tranformPx(12),
  m13: tranformPx(13),
  m14: tranformPx(14),
  m15: tranformPx(15),
  m16: tranformPx(16),
  m17: tranformPx(17),
  m18: tranformPx(18),
  m19: tranformPx(19),
  m20: tranformPx(20),
  m21: tranformPx(21),
  m22: tranformPx(22),
  m23: tranformPx(23),
  m24: tranformPx(24),
  m25: tranformPx(25),
  m26: tranformPx(26),
  m27: tranformPx(27),
  m28: tranformPx(28),
  m29: tranformPx(29),
  m30: tranformPx(30),
  m31: tranformPx(31),
  m32: tranformPx(32),
  m33: tranformPx(33),
  m34: tranformPx(34),
  m36: tranformPx(36),
  m35: tranformPx(35),
  m38: tranformPx(38),
  m39: tranformPx(39),
  m40: tranformPx(40),
  m42: tranformPx(42),
  m44: tranformPx(44),
  m46: tranformPx(46),
  m48: tranformPx(48),
  m50: tranformPx(50),
  m54: tranformPx(54),
  m55: tranformPx(55),
  m56: tranformPx(56),
  m64: tranformPx(64),
  m66: tranformPx(66),
  m72: tranformPx(72),
  m88: tranformPx(88),
  m98: tranformPx(98),
  m108: tranformPx(108),
  m195: tranformPx(195),
  m217: tranformPx(217),
  m240: tranformPx(240),
  m268: tranformPx(268),
  m321: tranformPx(321),
  m427: tranformPx(427),
  mMain: mainPadding,
};

export const fontWeight: {
  [key: string]:
    | "normal"
    | "bold"
    | "100"
    | "200"
    | "300"
    | "400"
    | "500"
    | "600"
    | "700"
    | "800"
    | "900"
    | undefined;
} = {
  f100: "100",
  f200: "200",
  f300: "300",
  f400: "400",
  f500: "500",
  f600: "600",
  f700: Platform.OS === "ios" ? "700" : undefined,
  f800: Platform.OS === "ios" ? "800" : undefined,
  f900: Platform.OS === "ios" ? "900" : undefined,
  fnormal: "normal",
  fbold: "bold",
};

export const marginHorizontal = {
  mh28: tranformPx(28),
  mh30: tranformPx(30),
  mhHead: mainPadding,
  mhMain: -mainPadding,
};

export const marginVertical = {
  mv48: tranformPx(48),
};

export const paddingHorizontal = {
  ph6: tranformPx(6),
  ph10: tranformPx(10),
  ph12: tranformPx(12),
  ph16: tranformPx(16),
  ph20: tranformPx(20),
  ph22: tranformPx(22),
  ph24: tranformPx(24),
  ph28: tranformPx(28),
  ph30: tranformPx(30),
  ph32: tranformPx(32),
  ph45: tranformPx(45),
  phMain: mainPadding,
};

export const paddingVertical = {
  pv4: tranformPx(4),
  pv5: tranformPx(5),
  pv6: tranformPx(6),
  pv12: tranformPx(12),
  pv14: tranformPx(14),
  pv16: tranformPx(16),
  pv18: tranformPx(18),
  pv22: tranformPx(22),
  pv20: tranformPx(20),
  pv24: tranformPx(24),
  pv28: tranformPx(28),
  pv30: tranformPx(30),
};

export const fontSize = {
  f8: tranformPx(8),
  f10: tranformPx(10),
  f11: tranformPx(11),
  f12: tranformPx(12),
  f13: tranformPx(13),
  f14: tranformPx(14),
  f15: tranformPx(15),
  f16: tranformPx(16),
  f18: tranformPx(18),
  f20: tranformPx(20),
  f22: tranformPx(22),
  f24: tranformPx(24),
  f26: tranformPx(26),
  f28: tranformPx(28),
  f30: tranformPx(30),
  f32: tranformPx(32),
  f34: tranformPx(34),
  f36: tranformPx(36),
  f40: tranformPx(40),
  f46: tranformPx(46),
  f47: tranformPx(47),
};

export const radius = {
  r1: tranformPx(1),
  r2: tranformPx(2),
  r3: tranformPx(3),
  r4: tranformPx(4),
  r5: tranformPx(5),
  r8: tranformPx(8),
  r10: tranformPx(10),
  r12: tranformPx(12),
  r13: tranformPx(13),
  r14: tranformPx(14),
  r15: tranformPx(15),
  r16: tranformPx(16),
  r17: tranformPx(17),
  r18: tranformPx(18),
  r20: tranformPx(20),
  r24: tranformPx(24),
  r26: tranformPx(26),
  r27: tranformPx(27),
  r30: tranformPx(30),
  r32: tranformPx(32),
  r36: tranformPx(36),
  r40: tranformPx(40),
  r48: tranformPx(48),
  r50: tranformPx(50),
  r56: tranformPx(56),
  r60: tranformPx(60),
  r80: tranformPx(80),
  r90: tranformPx(90),
  r120: tranformPx(120),
};

export const lineHeight = {
  l11: tranformPx(11),
  l12: tranformPx(12),
  l13: tranformPx(13),
  l15: tranformPx(15),
  l14: tranformPx(14),
  l16: tranformPx(16),
  l18: tranformPx(18),
  l19: tranformPx(19),
  l20: tranformPx(20),
  l21: tranformPx(21),
  l22: tranformPx(22),
  l23: tranformPx(23),
  l24: tranformPx(24),
  l26: tranformPx(26),
  l28: tranformPx(28),
  l30: tranformPx(30),
  l31: tranformPx(31),
  l32: tranformPx(32),
  l33: tranformPx(33),
  l36: tranformPx(36),
  l37: tranformPx(37),
  l38: tranformPx(38),
  l40: tranformPx(40),
  l42: tranformPx(42),
  l45: tranformPx(45),
  l46: tranformPx(46),
  l48: tranformPx(48),
  l56: tranformPx(56),
  l59: tranformPx(59),
  l60: tranformPx(60),
  l64: tranformPx(64),
  l88: tranformPx(88),
};

export const touchHitSlop = { top: 10, bottom: 10, left: 10, right: 10 };

export const letterSpacing = {};

export const flexDirection: {
  [key: string]: "row" | "column" | "row-reverse" | "column-reverse";
} = {
  row: "row",
  column: "column",
};

export const flexWrap: { [key: string]: "wrap" | "nowrap" | "wrap-reverse" | undefined } = {
  wrap: "wrap",
};

export const alignItems: { [key: string]: FlexAlignType | undefined } = {
  center: "center",
  stretch: "stretch",
  flexEnd: "flex-end",
  flexStart: "flex-start",
};

export const alignSelf: { [key: string]: "auto" | FlexAlignType | undefined } = {
  center: "center",
  stretch: "stretch",
  flexEnd: "flex-end",
  flexStart: "flex-start",
};

export const justifyContent: {
  [key: string]:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | undefined;
} = {
  center: "center",
  spaceBetween: "space-between",
  flexEnd: "flex-end",
  flexStart: "flex-start",
  spaceAround: "space-around",
};

export const justifySelf = {
  stretch: "stretch",
};

export const overflow: { [key: string]: "visible" | "hidden" | "scroll" | undefined } = {
  hidden: "hidden",
  visible: "visible",
};

export const textAlign: {
  [key: string]: "auto" | "left" | "right" | "center" | "justify" | undefined;
} = {
  left: "left",
  center: "center",
  right: "right",
};

export const textAlignVertical = {
  center: "center",
};

export const position: { [key: string]: "absolute" | "relative" | undefined } = {
  absolute: "absolute",
  relative: "relative",
};

export const textDecorationLine: { [key: string]: TextStyle["textDecorationLine"] } = {
  underline: "underline",
};

export const layoutCenter = {
  alignItems: alignItems.center,
  justifyContent: justifyContent.center,
  flex: 1,
  flexDirection: "row",
};

export const layoutAbsoluteFull = {
  position: position.absolute,
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

export const layoutColumnCenter = {
  alignItems: alignItems.center,
  justifyContent: justifyContent.center,
  flex: 1,
  flexDirection: "row",
};

export const zIndex = {
  z2: 2,
  z999: 999,
};

export const imageRounded12 = {
  width: width.w12,
  height: height.h12,
  borderRadius: radius.r12,
};

export const imageRounded20 = {
  width: width.w20,
  height: height.h20,
  borderRadius: radius.r20,
};

export const imageRounded30 = {
  width: width.w30,
  height: height.h30,
  borderRadius: radius.r30,
};

export const imageRounded32 = {
  width: width.w32,
  height: height.h32,
  borderRadius: radius.r32,
};

export const imageRounded24 = {
  width: width.w24,
  height: height.h24,
  borderRadius: radius.r24,
};

export const imageRounded40 = {
  width: width.w40,
  height: height.h40,
  borderRadius: radius.r40,
};

export const imageRounded50 = {
  width: width.w50,
  height: height.h50,
  borderRadius: radius.r50,
};

export const imageRounded56 = {
  width: width.w56,
  height: height.h56,
  borderRadius: radius.r56,
};

export const imageRounded60 = {
  width: width.w60,
  height: height.h60,
  borderRadius: radius.r60,
};

export const imageRounded80 = {
  width: width.w80,
  height: height.h80,
  borderRadius: radius.r80,
};

export const imageRounded120 = {
  width: width.w120,
  height: height.h120,
  borderRadius: radius.r120,
};

export const sectionTitleStyle = {
  fontSize: fontSize.f30,
  lineHeight: lineHeight.l38,
  color: colors.black,
  marginTop: margin.m48,
  paddingHorizontal: paddingHorizontal.ph30,
};

export const theme = {
  colors,
  padding,
  fontSize,
  radius,
};

// base styles
export const baseStyles = {
  appContainer: {
    flex: 1,
  },
  mainContainer: {
    flex: 1,
    paddingHorizontal: paddingHorizontal.phMain,
  },
  innerContainer: {
    flex: 1,
    marginHorizontal: marginHorizontal.mhMain,
  },
  commonPadding: {
    paddingHorizontal: paddingHorizontal.phMain,
  },
  commonMargin: {
    marginHorizontal: marginHorizontal.mhMain,
  },
  commonFlexRow: {
    flexDirection: flexDirection.row,
  },
  commonFlexColumn: {
    flexDirection: flexDirection.column,
  },
  rowBetweenCenter: {
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
    justifyContent: justifyContent.spaceBetween,
  },
  modalTitle: {
    fontSize: fontSize.f20,
    fontWeight: fontWeight.f500,
    fontFamily: fontFamily.commonMedium,
    lineHeight: tranformPx(28),
    color: colors.mainTextColor,
  },
  titleBlock: {
    backgroundColor: colors.black,
    width: width.w48,
    height: height.h6,
    borderRadius: radius.r3,
    marginBottom: margin.m20,
  },
  error: {
    color: colors.red2,
    fontSize: fontSize.f12,
    lineHeight: lineHeight.l14,
  },
  rowCenter: {
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
  },
  verticalCenter: {
    flexDirection: flexDirection.row,
    alignItems: alignItems.center,
    justifyContent: justifyContent.spaceBetween,
  },
  testButton: {
    width: 1,
    height: 1,
    top: 100,
    left: 100,
    position: position.absolute,
  },
  fontRegular: {
    fontWeight: fontWeight.f400,
    fontFamily: fontFamily.commonRegular,
  },
  fontSemiBold: {
    fontWeight: fontWeight.f500,
    fontFamily: fontFamily.commonMedium,
  },
  fontBold: {
    fontWeight: fontWeight.f700,
    fontFamily: fontFamily.commonBold,
  },
  wrapTxt: {
    flex: 1,
    fontSize: fontSize.f12,
    color: colors.highlightColor,
  },
};

export default function createStyles<T extends NamedStyles<T> | NamedStyles<any>>(
  overrides: T | NamedStyles<T>,
): T {
  return StyleSheet.create({ ...(baseStyles as unknown as T), ...overrides });
}

export const customViewProps = {
  style: {},
};

// Getting rid of that ugly line on Android and adding some custom style to all TextInput components.
export const customTextInputProps = {
  allowFontScaling: false,
  adjustsFontSizeToFit: false,
  underlineColorAndroid: "rgba(0,0,0,0)",
  autoComplete: "off",
  autoCapitalize: "none",
  importantForAutofill: "no",
  textContentType: "none",
  autoCorrect: false,
  style: {
    ...baseStyles.fontRegular,
    color: colors.mainTextColor,
    fontSize: fontSize.f16,
    padding: 0,
    textAlignVertical: "center",
    spellCheck: false,
  },
};

// Setting default styles for all Text components.
export const customTextProps = {
  allowFontScaling: false,
  adjustsFontSizeToFit: true,

  style: {
    ...baseStyles.fontRegular,
    fontSize: fontSize.f16,
    color: colors.mainTextColor,
    letterSpacing: 0.5,
  },
};

export const splitLineHeight = 1;
